module.exports = __webpack_public_path__ + "static/EFES26-cba40b60dc260bb93d3d09e22bf5f1d8.png";